var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['sw-icon-button',
  {
    'sw-icon-button--selected': _vm.selected,
    'sw-icon-button--disabled': _vm.disabled,
    'sw-icon-button--divider': _vm.isDivider,
    'sw-icon-button--no-border': _vm.noBorder,
  },
  ("sw-icon-button--" + _vm.theme)],style:(_vm.effectiveButtonConfig),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_c('span',{class:['sw-icon-button__inner', 'sw-flexbox',
    'sw-flexbox--center-items', 'sw-flexbox--center-justify']},[_c('sw-icon',_vm._b({attrs:{"as-block":""}},'sw-icon',_vm.effectiveIconConfig,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }